<template>
  <div class="hello">
    <div class="header">
      <div class="top">
        <a href="/" class="logo"></a>
        <img class="logo_game" src="../assets/logo_game.jpg" alt=""/>
        <ul class="nav">
          <li><a @click="$router.push('/')">平台首页</a></li>
          <li class="active"><a @click="$router.push('/about')">关于我们</a></li>
          <li><a @click="$router.push('/game')">开始游戏</a></li>
          <li><a @click="$router.push('/pay')">支付</a></li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="info">
        <div class="title">
          <p class="p1">About Us</p>
          <p class="p2">
            关于<span>我们</span>
          </p>
        </div>
        <div class="text">
          <div class="fl">
            <p><img src="../assets/about.14ed58b.png" /></p>
          </div>
          <div class="fr">
            <p>
              海南丰际网络科技有限公司（简称“海南丰际”）作为一家专注于手机游戏研发、发行和运营服务的移动游戏公司，成立之时就定下了“精品化、平台化、全球化”的企业发展战略。海南丰际一直秉承着"志存高远、厚积薄发"的经营思路稳步前行，坚持着技术领先、理念领先、管理领先的战略，以运营"世界级精品游戏"为目标！
            </p>
            <h1>我们的目标</h1>
            <p>成为国内最具影响力的研运一体化游戏企业。</p>
            <h1>我们的愿景</h1>
            <p>
              公司致力于在未来5年内孵化3个爆款IP，服务2亿用户；10年内孵化2个现象级IP，服务5亿用户。公司使命是“创精品，造快乐”，始终坚持“以用户为中心，以产品为核心”的业务理念，在未来希望与每位合作伙伴携手并进、实现双赢。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <div class="fl"><a href=""><img style="width:200px" src="../assets/logo.jpg" alt=""></a></div>
        <div class="fr">
          <p>健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排 时间享受健康生活</p>
          <p>ICP 备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">琼ICP备19004874号-1</a></p>
          <p>公司名称：海南丰际网络科技有限公司</p>
          <p>公司地址：海南省澄迈县老城镇高新技术产业示范区海南生态软件园A17幢二层4001室</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  data () {
    return {
    }
  }
}
</script>
<style scoped>
ul,
li {
  list-style: none;
}
.logo_game{
  height: 50%;
    position: relative;
    top: 39%;
    left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue